import { Redirect, Route, RouteProps } from "react-router-dom";
import { getAccessToken } from "services/auth";

type PrivateRouteProps = RouteProps;

function PrivateRoute({ ...rest }: PrivateRouteProps) {
  const auth = getAccessToken();
  if (auth == null) {
    let redirectUrl = window.location.pathname + window.location.search;
    // Legacy hash-style links (e.g. "/#/project/...") carry the target in the
    // hash — only then does the hash win. Otherwise keep path+query so invite
    // params (?token=&projectId=) survive the bounce to /login.
    if (
      window.location.hash &&
      (window.location.pathname === "/" || window.location.pathname === "")
    ) {
      redirectUrl = window.location.hash.substring(1);
    }
    return <Redirect to={`/?redirectUrl=${encodeURIComponent(redirectUrl)}`} />;
  }
  return <Route {...rest} />;
}

export default PrivateRoute;
